// Extends themes theme.js

//SIZE LOCALIZATION EU/UK/US START
const sizeConverts = {
  0: { us: "W 5", eu: "35", uk: "W 2" },
  1: { us: "W 6", eu: "36", uk: "W 3" },
  2: { us: "W 7", eu: "37", uk: "W 4" },
  3: { us: "W 8", eu: "38", uk: "W 5" },
  4: { us: "W 9 / M 6", eu: "39", uk: "W 6 / M 5" },
  5: { us: "W 10 / M 7", eu: "40", uk: "W 7 / M 6" },
  6: { us: "W 11 / M 8", eu: "41", uk: "W 8 / M 7" },
  7: { us: "W 12 / M 9", eu: "42", uk: "W 9 / M 8" },
  8: { us: "W 13 / M 10", eu: "43", uk: "W 10 / M 9" },
  9: { us: "M 11", eu: "44", uk: "M 10" },
  10: { us: "M 12", eu: "45", uk: "M 11" },
  11: { us: "M 13", eu: "46", uk: "M 12" },
  12: { us: "M 14", eu: "47", uk: "M 13" },
  13: { us: "M 15", eu: "48", uk: "M 14" },
  14: { us: "11", eu: "28", uk: "10" },
  15: { us: "12", eu: "29", uk: "11" },
  16: { us: "13", eu: "30", uk: "12" },
  17: { us: "1", eu: "31", uk: "13" },
  18: { us: "2", eu: "32", uk: "1" },
  19: { us: "3", eu: "33", uk: "2" },
  20: { us: "4", eu: "34", uk: "3" },
  21: { us: "W 5-6", eu: "35-36", uk: "W 3-4" },
  22: { us: "W 7-9 / M 6", eu: "37-39", uk: "W 5-7 / M 5.5" },
  23: { us: "W 10-11 / M 7-9", eu: "40-42", uk: "W 8-9 / M 6.5-8.5" },
  24: { us: "W 12 / M 10-11.5", eu: "43-45", uk: "W 10 / M 9.5-11" },
  25: { us: "M 12.5-14.5", eu: "46-48", uk: "M 12-14" },
  26: { us: "W 4-5", eu: "34-35", uk: "W 1-2" },
  27: { us: "W 6-7", eu: "36-37", uk: "W 3-4" },
  28: { us: "W 8-9 / M 6", eu: "38-39", uk: "W 5-6 / M 5" },
  29: { us: "W 10-11 / M 7-8", eu: "40-41", uk: "W 7-8 / M 6-7" },
  30: { us: "W 12-13 / M 9-10", eu: "42-43", uk: "W 9-10 / M 8-9" },
  31: { us: "M 11-12", eu: "44-45", uk: "M 10-11" },
  32: { us: "M 13-14", eu: "46-47", uk: "M 12-13" },
};

const defaultSizeToUS = ["US", "CA","AU","NZ"];
const defaultSizeToUK = ["GB", "IE"];

function getCookie(name) {
  return document.cookie.split('; ').find(row => row.startsWith(name))?.split('=')[1];
}

function setCookie(name, value, days = 365) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value}; expires=${d.toGMTString()}; path=/`;
}

function getSizeConversion(euSize, targetFormat) {
  const index = Object.values(sizeConverts).findIndex(size => size.eu === euSize);
  return index !== -1 ? sizeConverts[index][targetFormat] : null;
}

// QUICKBUY SIZE LOCALIZATION
function initializeQuickbuySizeLocalization(quickbuyDrawer) {
  if (!quickbuyDrawer) return;
  
  const sizeSystem = getCookie("size_localization") || "EU";
  const labels = quickbuyDrawer.querySelectorAll(".block-swatch");
  
  if (labels.length === 0) return;
  
  labels.forEach(label => {
    const trimmedText = label.textContent.trim();
    
 
    let index = Object.values(sizeConverts).findIndex(
      size => size[sizeSystem.toLowerCase()] === trimmedText
    );
    
   
    if (index === -1) {
      index = Object.values(sizeConverts).findIndex(size => size.us === trimmedText);
    }
    if (index === -1) {
      index = Object.values(sizeConverts).findIndex(size => size.uk === trimmedText);
    }
    
    if (index === -1) {
      index = Object.values(sizeConverts).findIndex(size => size.eu === trimmedText);
    }
    
    if (index !== -1) {
      if (sizeSystem !== "EU") {
       
        const convertedSize = sizeConverts[index][sizeSystem.toLowerCase()];
        if (convertedSize) {
          label.textContent = convertedSize;
          label.classList.add("block-swatch--nonEu");
          label.classList.add("non-eu-quickbuy-label");
        }
      } else {
      
        label.textContent = sizeConverts[index].eu;
        label.classList.remove("block-swatch--nonEu");
        label.classList.remove("non-eu-quickbuy-label");
      }
    }
  });
}


// PRODUCT PAGE SIZE SWITCHING
function initializeSizeLocalization() {
  const blockSwatch = document.querySelector(".block-swatch");
  const euButton = document.getElementById("size-localization__btn--EU");
  
  if (!blockSwatch || !euButton) return;

  const sizeLocalButtons = {
    US: document.getElementById("size-localization__btn--US"),
    EU: euButton,
    UK: document.getElementById("size-localization__btn--UK"),
  };
  
  const usSizeProperty = document.getElementById("us-sizes-property");
  const ukSizeProperty = document.getElementById("uk-sizes-property");
  const labels = document.querySelectorAll(".block-swatch");
  const sizeLabel = document.querySelectorAll(".variant-picker__option-info .h-stack span");
  const sizeOptionContainer = document.querySelector(".size-option-container");
  let currentSize = getCookie("size_localization") || "EU";
  // Event listeners
  Object.keys(sizeLocalButtons).forEach(key => 
    sizeLocalButtons[key].addEventListener("click", () => localizeSize(key, false))
  );

  labels.forEach(label => 
    label.addEventListener("click", () => updateSizeLabel(label.textContent))
  );

  function updateSizeLabel(sizeText) {
    if (currentSize === "EU") return;
    
    const index = Object.values(sizeConverts).findIndex(
      size => size[currentSize.toLowerCase()] === sizeText
    );
    
    if (index !== -1) {
      sizeLabel[sizeLabel.length - 1].textContent = `${sizeConverts[index].eu} / ${sizeText}`;
      
      if (currentSize === "UK") {
        ukSizeProperty.value = sizeText;
        ukSizeProperty.disabled = false;
        usSizeProperty.disabled = true;
      } else if (currentSize === "US") {
        usSizeProperty.value = sizeText;
        usSizeProperty.disabled = false;
        ukSizeProperty.disabled = true;
      } else {
        ukSizeProperty.disabled = true;
        usSizeProperty.disabled = true;
      }
    }
  }
  
  function localizeSize(to, initial=true) {
    labels.forEach(label => {
      const trimmedText = label.textContent.trim();
      

      let index = Object.values(sizeConverts).findIndex(
        size => size[currentSize.toLowerCase()] === trimmedText
      );
      
      if (index === -1) {
        index = Object.values(sizeConverts).findIndex(size => size.eu === trimmedText);
      }
      
      if (index !== -1) {
        label.textContent = sizeConverts[index][to.toLowerCase()] || label.textContent;
      }
      
      label.classList.toggle("block-swatch--nonEu", to !== "EU");
    });
   // sizeOptionContainer.classList.toggle("size-option-container--nonEu", to !== "EU");
    currentSize = to;
    toggleActiveButton(to);
    if (initial === false) {
    setCookie("size_localization", to);
    }
    
    // Update all quickbuy drawers when size changes on PDP
    document.querySelectorAll("quick-buy-drawer").forEach(drawer => {
      if (drawer.hasAttribute("open")) {
        initializeQuickbuySizeLocalization(drawer);
      }
    });
  }
  
  function toggleActiveButton(active) {
    Object.keys(sizeLocalButtons).forEach(key =>
      sizeLocalButtons[key].classList.toggle("size-localization__btn--active", key === active)
    );
  }


  const location = euButton.dataset.location;
  if (getCookie("size_localization")) localizeSize(currentSize)
  else if (defaultSizeToUS.includes(location)) localizeSize("US");
  else if (defaultSizeToUK.includes(location)) localizeSize("UK");
  else localizeSize(currentSize);
}

// COLLECTION PAGE SIZE SWITCHING
function initializeCollectionSizeSwitching() {
  const euButton = document.getElementById("eu-button");
  if (!euButton) return;
  
  const location = euButton.getAttribute("data-location");
  const default_to = defaultSizeToUS.includes(location) ? "US" : 
                     defaultSizeToUK.includes(location) ? "UK" : "EU";
  
  const sizeSystem = getCookie('size_localization') || default_to;
  switchSize(sizeSystem);
  changeActiveFilter(sizeSystem);
}

function switchSize(sizeFormat) {

  let sizeAccordion = document.querySelector('details[id*="accordion-filter.v.option.size"]') ||
                      document.querySelector('details[id*="accordion-filter-v-option-size"]');
  
  if (!sizeAccordion) {
    const allAccordions = document.querySelectorAll('details.accordion');
    sizeAccordion = Array.from(allAccordions).find(accordion => 
      accordion.querySelector('.size-switcher')
    );
  }
  
  if (!sizeAccordion) return;
  
  const sizeElements = sizeAccordion.querySelectorAll('.checkbox-container[data-eu-size]');
  
  if (getCookie('size_localization')) {
    setCookie("size_localization", sizeFormat);
  }
  
  sizeElements.forEach(element => {
    const euSize = element.getAttribute('data-eu-size');
    const label = element.querySelector('label');
    if (!label) return;
    
    if (sizeFormat === 'EU') {
      label.innerText = euSize;
    } else {
      const convertedSize = getSizeConversion(euSize, sizeFormat.toLowerCase()) || euSize;
      label.innerText = convertedSize;
    }
  });
  
  updateButtonStates(sizeFormat);
}

function changeActiveFilter(sizeSystem) {
  const activeFiltersContainers = document.querySelectorAll(".active-facets");
  
  activeFiltersContainers.forEach(container => {
    const activeFilterButtons = container.querySelectorAll('div.removable-facet[data-size-button="true"]');
    
    activeFilterButtons.forEach(filter => {
      const textNodes = Array.from(filter.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
      
      if (textNodes.length > 0) {
        const textNode = textNodes[0];
        const euSize = filter.getAttribute("data-eu-size");
        const currentText = textNode.textContent.trim();
        
        let newSizeValue;
        if (sizeSystem === 'EU') {
          newSizeValue = euSize;
        } else {
          newSizeValue = getSizeConversion(euSize, sizeSystem.toLowerCase()) || euSize;
        }
        
        if (currentText.includes(':')) {
          const parts = currentText.split(':');
          textNode.textContent = `${parts[0]}: ${newSizeValue}`;
        } else {
          textNode.textContent = newSizeValue;
        }
      }
    });
  });
}

function updateButtonStates(activeSize) {
  document.querySelectorAll('.size-switcher-button').forEach(btn => {
    btn.classList.remove("size-localization__btn--active");
  });
  
  document.querySelectorAll(`button[data-size="${activeSize}"]`).forEach(btn => {
    btn.classList.add("size-localization__btn--active");
  });
}


document.addEventListener("variant:change", initializeSizeLocalization);
document.addEventListener('DOMContentLoaded', function () {

  initializeSizeLocalization();
  
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('size-switcher-button')) {
      event.preventDefault();
      event.stopPropagation();
      const selectedSizeFormat = event.target.getAttribute('data-size');
      switchSize(selectedSizeFormat);
      changeActiveFilter(selectedSizeFormat);
    }
  });

  initializeCollectionSizeSwitching();

  ['facet:update', 'facet:rerenderComplete'].forEach(eventType => {
    window.addEventListener(eventType, () => {
      initializeCollectionSizeSwitching
    });
  });
  

  const observer = new MutationObserver((mutations) => {
    const hasActiveFilterChanges = mutations.some(mutation => 
      mutation.type === 'childList' && 
      Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes))
        .some(node => node.nodeType === Node.ELEMENT_NODE && 
              (node.classList?.contains('active-facets') || node.querySelector?.('.active-facets')))
    );
    
    if (hasActiveFilterChanges) {
      const sizeSystem = getCookie('size_localization') || 
                        (defaultSizeToUS.includes(document.getElementById("eu-button")?.getAttribute("data-location")) ? "US" : 
                         defaultSizeToUK.includes(document.getElementById("eu-button")?.getAttribute("data-location")) ? "UK" : "EU");
      changeActiveFilter(sizeSystem);
      initializeCollectionSizeSwitching();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
 
  const quickbuyObserver = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const drawer = mutation.target;
        if (drawer.tagName === 'QUICK-BUY-DRAWER' && drawer.hasAttribute('open')) {
          
          setTimeout(() => {
            initializeQuickbuySizeLocalization(drawer);
          }, 50);
        }
      }
      
     
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const quickbuyDrawer = node.closest('quick-buy-drawer') || 
                                 (node.tagName === 'QUICK-BUY-DRAWER' ? node : null);
            if (quickbuyDrawer && quickbuyDrawer.hasAttribute('open')) {
          
              initializeQuickbuySizeLocalization(quickbuyDrawer);
            }
          }
        });
      }
    });
  });
  
 
  document.querySelectorAll('quick-buy-drawer').forEach(drawer => {
    quickbuyObserver.observe(drawer, { 
      attributes: true, 
      attributeFilter: ['open'],
      childList: true,
      subtree: true 
    });
  });
  

  const quickbuyDrawerObserver = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'QUICK-BUY-DRAWER') {
          quickbuyObserver.observe(node, { 
            attributes: true, 
            attributeFilter: ['open'],
            childList: true,
            subtree: true 
          });
        } else if (node.nodeType === Node.ELEMENT_NODE && node.querySelector) {
          node.querySelectorAll('quick-buy-drawer').forEach(drawer => {
            quickbuyObserver.observe(drawer, { 
              attributes: true, 
              attributeFilter: ['open'],
              childList: true,
              subtree: true 
            });
          });
        }
      });
    });
  });
  
  quickbuyDrawerObserver.observe(document.body, { childList: true, subtree: true });
  

  document.addEventListener('variant:change', function(event) {
    const quickbuyDrawer = event.target.closest('quick-buy-drawer');
    if (quickbuyDrawer) {
      initializeQuickbuySizeLocalization(quickbuyDrawer);
    }
  });
});



// Klaviyo popup
document.getElementById("klaviyo-popup-trigger")?.addEventListener("click", function() {
  window._klOnsite?.push(['openForm', 'Xp8gHk']);
});